import { CryptographyProviderwgv0x40nzvjc as CryptographyProvider } from '../../../../../../cryptography-kotlin-cryptography-core/dev/whyoleg/cryptography/CryptographyProvider.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { lazy2hsh8ze7j6ikd as lazy } from '../../../../../../kotlin-kotlin-stdlib/kotlin/kotlin.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function get_defaultProvider() {
  _init_properties_WebCryptoCryptographyProvider_kt__i22tls();
  return defaultProvider;
}
var defaultProvider;
var WebCrypto$delegate;
var WebCryptoCryptographyProviderClass;
function WebCryptoCryptographyProvider() {
  if (WebCryptoCryptographyProviderClass === VOID) {
    class $ extends CryptographyProvider() {
      constructor() {
        WebCryptoCryptographyProvider_instance = null;
        super();
        WebCryptoCryptographyProvider_instance = this;
      }
    }
    initMetadataForObject($, 'WebCryptoCryptographyProvider');
    WebCryptoCryptographyProviderClass = $;
  }
  return WebCryptoCryptographyProviderClass;
}
var WebCryptoCryptographyProvider_instance;
function WebCryptoCryptographyProvider_getInstance() {
  if (WebCryptoCryptographyProvider_instance === VOID)
    new (WebCryptoCryptographyProvider())();
  return WebCryptoCryptographyProvider_instance;
}
function defaultProvider$lambda() {
  _init_properties_WebCryptoCryptographyProvider_kt__i22tls();
  return WebCryptoCryptographyProvider_getInstance();
}
var properties_initialized_WebCryptoCryptographyProvider_kt_n89q9u;
function _init_properties_WebCryptoCryptographyProvider_kt__i22tls() {
  if (!properties_initialized_WebCryptoCryptographyProvider_kt_n89q9u) {
    properties_initialized_WebCryptoCryptographyProvider_kt_n89q9u = true;
    defaultProvider = lazy(defaultProvider$lambda);
    WebCrypto$delegate = get_defaultProvider();
  }
}
//region block: exports
export {
  get_defaultProvider as get_defaultProvider1a56q6a181l5h,
};
//endregion

//# sourceMappingURL=WebCryptoCryptographyProvider.mjs.map
